module.exports = "data:image/webp;base64,UklGRp4BAABXRUJQVlA4IJIBAACwBwCdASoZABkAPpFAmkmlo6IhKAqosBIJZgCdIIlkm9AZa3Y4LGr/kvuA+MfO5KxMWDpH8PVmBBHwagOlpidH+67ISiYAAP7sDib5VNOWbMOJOsdHpBP7T4Y3HjHxZdniU8PaGP0ATmqHf3EKd1W+SABjUTdPWp3Dn7/Jqdx0Dji7JiC3J1mFVI3vhHe3nZpDSik1/oV4pHqum3R5icp2aG9EdMkRx3YcF1MEMloA/hRg4VXsSpVImB2PZugYmFDzGd+Kjb8ZJyUWczLp6bbiM8bizy+xr5OynM4BcoabdV5EOruGyPz1YH5SZpCCsfJk37jqPd5K7u2xe8ROSPEH+Cn3netckF5aFhua+ZTW/8SeU4qCAaqRkJdPMfuLoAz3U5NWe+4/zkeo35FdpcymfuWd40NfbDegeYcHCacN/P9QegqQcG3CwW52su+FW/hrQkzafeYzNHUG/ZGc7Evbg1S6fc3eZRf+qXppx31rKaqeIsrusyI5C78HBta8vIRiJlSzAeKBFEvcTvQ/unjJIAA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/multi.webp
// module id = xdF+
// module chunks = 14